import { defineComponent, inject, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import classNames from 'classnames'
import { getCityInfo } from '@/pages/chargermap/utils/gis'
import styles from './styles.module.scss'
import Tracker from '@nio-fe/nio-tracker-web'
import { AreaInfo, MapViewMode } from '@/pages/chargermap/contract/map'
import { useComponentStore } from '@/pages/chargermap/nsh5/localStores/component'
import { useAppStore } from '@/pages/chargermap/stores/app'
import { AREA_LIST, AREA_LIST_OF_COUNTY_LAYOUT } from '@/pages/chargermap/config/area'

interface ITabItem {
  name: string
  active: boolean
  placeholder: boolean
  list: AreaInfo[]
  data?: AreaInfo
}

export default defineComponent({
  name: 'choose-city-view',
  setup: () => {
    const client = inject<string>('client', '')
    const router = useRouter()
    const route = useRoute()
    const componentStore = useComponentStore()
    const appStore = useAppStore()

    console.log('===============componentStore.viewMode=====================')
    console.log(componentStore.viewMode)
    console.log('====================================')
    const getList = () => {
      switch (componentStore.viewMode) {
        case MapViewMode.CountyLayout:
          return AREA_LIST_OF_COUNTY_LAYOUT

        default:
          return AREA_LIST
      }
    }

    const LIST = getList()

    const placeholderTabItem: ITabItem = {
      name: '请选择',
      active: true,
      placeholder: true,
      list: LIST,
    }

    let cityList: AreaInfo[] = []

    const state = reactive({
      list: LIST,
      tabItems: [placeholderTabItem],
      selectedTabName: '',
    })

    const updateActiveTabItem = (item: ITabItem) => {
      for (const item of state.tabItems) {
        item.active = false
      }
      item.active = true
      state.list = item.list
      state.selectedTabName = item.name
    }

    const handleSelectTabItem = (item: ITabItem) => {
      updateActiveTabItem(item)
    }

    const handleSelectListItem = async (item: AreaInfo) => {
      const scrollWrapper = document.getElementById('scrollWrapper')
      scrollWrapper!.scrollTop = 0
      if (item.name != '全部') {
        if (item?.cities?.length) {
          const tabItem: ITabItem = {
            name: item.name,
            active: false,
            placeholder: false,
            data: item,
            list: LIST,
          }
          cityList = LIST.filter((a: any) => a.name == item.name)[0].cities!
          placeholderTabItem.list = item?.cities
          placeholderTabItem.active = true
          state.tabItems = [tabItem, placeholderTabItem]
          updateActiveTabItem(placeholderTabItem)
          return
        }
        if (item?.districts?.length) {
          const tabItem: ITabItem = {
            name: item.name,
            active: false,
            placeholder: false,
            data: item,
            list: cityList,
          }
          placeholderTabItem.list = item?.districts
          placeholderTabItem.active = true
          if (state.tabItems.length == 3) {
            state.tabItems.splice(1, 1)
          }
          state.tabItems.splice(1, 0, tabItem)
          updateActiveTabItem(placeholderTabItem)
          return
        }
      }
      if (item.name == '全国') {
        state.selectedTabName = item.name
        state.tabItems = [
          {
            name: item.name,
            active: true,
            placeholder: true,
            data: item,
            list: [],
          },
        ]
      } else {
        state.tabItems[state.tabItems.length - 1] = {
          name: item.name,
          active: true,
          placeholder: true,
          data: item,
          list: [],
        } as ITabItem
      }
      trackFn()
      componentStore.bus.emit('selectCity', getCityInfo(item.simple))
      if (client === 'mobile') {
        // debugger
        componentStore.bus.emit('hideSummary')
        componentStore.bus.emit('closePopup')
        componentStore.bus.emit('preventZoomDragAction', 4000)
        if (route.name == 'data_chooseCity') {
          // console.log('====================================')
          // console.log(1111111)
          // console.log('====================================')
          // 数据面板选择城市
          // window.backHistoryNum--
          console.log('====================================')
          console.log(window.backHistoryNum)
          console.log('====================================')
          await router.go(-1)
          // window.backHistoryNum++
          // router.push({
          //   name: 'data_summary',
          //   state: {
          //     backHistoryNum: window.backHistoryNum,
          //   },
          // })
        } else if (route.name == 'countyLayout') {
          // 县县通选择完地址后留在县县通页面
        } else {
          // 移动端处理
          setTimeout(() => {
            // console.log('====================================')
            // console.log(2222222)
            // console.log(window.backHistoryNum)
            // console.log('====================================')
            // debugger
            // 首页打开数据面板
            window.backHistoryNum++
            router.push({
              name: 'data_summary',
              state: {
                backHistoryNum: window.backHistoryNum,
              },
            })
            console.log('====================================')
            console.log(window.backHistoryNum)
            console.log('====================================')
          }, 4000)
        }
      } else {
        // debugger
        // console.log('====================================')
        // console.log(3333333)
        // console.log('====================================')
        window.backHistoryNum--
        console.log('===============window.backHistoryNum=====================')
        console.log(window.backHistoryNum)
        console.log('====================================')
        router.go(-1)
      }
    }

    /**
     * 埋点
     * @param selectcityname 选择城市名
     * @param dimension 选择维度
     */
    const trackFn = () => {
      let selectcityname = '全国'
      let dimension = '全国'
      const tabLen = state.tabItems.length
      const lastTab = state.tabItems[tabLen - 1]
      switch (tabLen) {
        case 2:
          if (lastTab.name == '全部') {
            selectcityname = state.tabItems[0].name
            dimension = '省'
          }
          break
        case 3:
          if (lastTab.name == '全部') {
            selectcityname = state.tabItems[1].name
            dimension = '市'
          } else {
            selectcityname = lastTab.name
            dimension = '区县'
          }
          break

        default:
          break
      }
      componentStore.$patch({ dimension })
      Tracker.track(
        'nsh5_cityselect',
        Object.assign({ selectcityname, dimension }, appStore.trackParamsCommon)
      )
    }

    return () => {
      return (
        // NS大屏地址选择
        <div class={styles.cities}>
          <div class={styles.title}>切换城市</div>
          <div class={styles.tabs}>
            {state.tabItems.map((item) => (
              <>
                <div
                  class={classNames(styles.tab, {
                    [styles.active]: item.active,
                    [styles.placeholder]: item.placeholder,
                  })}
                  onClick={() => handleSelectTabItem(item)}
                >
                  {item.name}
                </div>
                {item.placeholder ? null : (
                  <div class={styles.arrow}>
                    <ns-icon name="arrow-fill" size="16" color="#CDCED4" />
                  </div>
                )}
              </>
            ))}
          </div>
          <div class={styles.wrapper} id="scrollWrapper">
            <div class={styles.list}>
              {state.list.map((item: any) => (
                <div
                  class={classNames(styles.item, {
                    [styles.selected]: item.name === state.selectedTabName,
                  })}
                  onClick={() => handleSelectListItem(item)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      )
    }
  },
})
